import type { Kernel } from "@crialume/core";
import { KernelProvider } from "@crialume/core/react";
import { IconProvider, Toaster } from "@crialume/ui";
import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { ConsentBanner } from "../analytics/consent-banner";

export function AppProviders({
  kernel,
  queryClient,
  children,
}: {
  kernel: Kernel;
  queryClient: QueryClient;
  children: ReactNode;
}) {
  return (
    <KernelProvider kernel={kernel}>
      <QueryClientProvider client={queryClient}>
        <IconProvider>
          {children}
          <Toaster />
          <ConsentBanner />
        </IconProvider>
      </QueryClientProvider>
    </KernelProvider>
  );
}
